"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var LftTag_styles_1 = require("./LftTag.styles");
var LftIconBase_1 = __importDefault(require("../LftIconBase"));
var LftTag = function (_a) {
    var ariaLabel = _a.ariaLabel, bgColor = _a.bgColor, children = _a.children, dataElement = _a.dataElement, dataInfo = _a.dataInfo, dataTestId = _a.dataTestId, id = _a.id, icon = _a.icon, _b = _a.label, label = _b === void 0 ? 'Tag Label' : _b, _c = _a.size, size = _c === void 0 ? 'lg' : _c, _d = _a.status, status = _d === void 0 ? 'default' : _d, lftClick = _a.lftClick;
    var tagLabel = typeof children === 'string' ? children : label;
    if (dataElement) {
        if (!dataElement.includes('_')) {
            dataElement = "button_" + dataElement;
        }
    }
    if (lftClick) {
        return ((0, jsx_runtime_1.jsxs)(LftTag_styles_1.TagButton, __assign({ "aria-label": ariaLabel ? ariaLabel : tagLabel, bgColor: bgColor, "data-element": dataElement, "data-info": dataInfo, "data-lift": "lft-tag", "data-testid": dataTestId ? dataTestId : id && id, id: id, size: size, status: status, tabIndex: 0, type: "button", onClick: lftClick }, { children: [!!icon && (0, jsx_runtime_1.jsx)(LftIconBase_1.default, { icon: icon, size: 'sm' }, void 0), tagLabel] }), void 0));
    }
    else {
        return ((0, jsx_runtime_1.jsxs)(LftTag_styles_1.TagDiv, __assign({ "aria-label": ariaLabel ? ariaLabel : tagLabel, bgColor: bgColor, "data-element": dataElement, "data-info": dataInfo, "data-lift": "lft-tag", "data-testid": dataTestId ? dataTestId : id && id, id: id, size: size, status: status, tabIndex: -1 }, { children: [!!icon && (0, jsx_runtime_1.jsx)(LftIconBase_1.default, { icon: icon, size: 'sm' }, void 0), tagLabel] }), void 0));
    }
};
exports.default = LftTag;
